import React from 'react';
import { Redirect, Route, withRouter } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { Flex } from 'rebass';
import withSession from '../../../lib/withSession';
import { DurationSelectionNoKit } from './DurationSelection';
import { Mutation } from 'react-apollo';
import { CREATE_SESSION_GI_CHECKOUT_SESSION } from '../../../graphql';
import { CompleteNoKit } from './CompleteKit';
import UploadGILabResults from './UploadGILabResults';
import { SubscribeKitQuestion } from './SubscribeKitQuestion';
import { InterestedPurchasedKit } from './InterestedPurchasedKit';
import { PurchaseTinyHealthKit } from './PurchaseTinyHealthKit';

export const SUBSCRIBE_GUT_RESET = '/programs/gut-reset/subscribe';

const SubscribeGutReset = ({ history, session }) => {
  const { refetch } = session;
  return (
    <>
      <Route
        path={`${SUBSCRIBE_GUT_RESET}/`}
        exact
        render={(props) => (
          <Flex flexDirection={'column'}>
            <Mutation
              mutation={CREATE_SESSION_GI_CHECKOUT_SESSION}
              onCompleted={async (res) => {
                let sessionId = null;
                if (res.createGiCheckoutSession) {
                  sessionId = res.createGiCheckoutSession.sessionId;
                }
                if (!sessionId) {
                  return;
                }
                const stripePromise = loadStripe(window._env_.REACT_APP_STRIPE_KEY);
                const stripe = await stripePromise;
                await stripe.redirectToCheckout({
                  sessionId: sessionId,
                });
              }}
            >
              {(createSession, { loading }) => (
                <DurationSelectionNoKit
                  onContinue={(d) => {
                    // history.push(`${SUBSCRIBE_GUT_RESET}/has-results`);
                    createSession({
                      variables: {
                        forwardUrl: `programs/gut-reset/subscribe/has-results`,
                        cancel_url: `programs/gut-reset/subscribe/`,
                        duration: d,
                        withKit: false,
                      },
                    });
                  }}
                />
              )}
            </Mutation>
          </Flex>
        )}
      />

      <Route
        path={`${SUBSCRIBE_GUT_RESET}/has-results`}
        render={(props) => (
          <SubscribeKitQuestion
            refetch={refetch}
            onContinueWithResults={() => {
              history.push(`${SUBSCRIBE_GUT_RESET}/upload-results`);
            }}
            onContinueWithoutResults={() => {
              history.push(`${SUBSCRIBE_GUT_RESET}/interested-in-kit`);
            }}
          />
        )}
      />

      <Route
        path={`${SUBSCRIBE_GUT_RESET}/upload-results`}
        render={(props) => (
          <UploadGILabResults
            onSubmitted={() => {
              history.push(`${SUBSCRIBE_GUT_RESET}/complete`);
            }}
            onSkip={() => {
              history.push(`${SUBSCRIBE_GUT_RESET}/complete`);
            }}
          />
        )}
      />

      <Route
        path={`${SUBSCRIBE_GUT_RESET}/interested-in-kit`}
        render={(props) => (
          <InterestedPurchasedKit
            onContinueWithKit={() => {
              history.push(`${SUBSCRIBE_GUT_RESET}/complete-with-kit`);
            }}
            onContinueWithoutKit={() => {
              history.push(`${SUBSCRIBE_GUT_RESET}/complete`);
            }}
          />
        )}
      />

      <Route path={`${SUBSCRIBE_GUT_RESET}/complete`} render={(props) => <CompleteNoKit />} />

      <Route
        path={`${SUBSCRIBE_GUT_RESET}/complete-with-kit`}
        render={(props) => (
          <CompleteNoKit
            wantsKit={() => {
              history.push(`${SUBSCRIBE_GUT_RESET}/purchase-your-kit`);
            }}
          />
        )}
      />

      <Route
        path={`${SUBSCRIBE_GUT_RESET}/purchase-your-kit`}
        render={(props) => (
          <PurchaseTinyHealthKit
            onBuy={() => {
              window.open('https://bit.ly/48Y92Hw', '_blank');
              history.push(`/programs/gut-reset`);
            }}
            onLater={() => {
              history.push(`/programs/gut-reset`);
            }}
          />
        )}
      />
    </>
  );
};

export default withRouter(withSession(SubscribeGutReset));
